/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext, useEffect, useState } from 'react';
import { DatePicker, If } from '@cleartax/zoids';
import moment from 'moment';

import INVSummary from './invSummaryCard/invSummary';
import InvoicesList from './invList/invoicesList';

import { UserContext } from '../context/userContext';
import {
  INVToolBar,
  INVContainer,
  Container,
  // INVFooter,
  // FooterBtn,
  // FooterLine,
} from './styles';
import { DateRange, DateRangeText, RangeText } from '../mis/styles';
import { CALENDAR, LOADER_BLUE, NO_INVOICE_FOUND } from '../../constants/urls';
import { useGlobalState } from '../context/qrState';
import {
  BusinessLevels,
  IRNSummaryDetails,
  EinvoiceSummaryDTO,
  Range,
  ToastNature,
  ErrorToastText,
} from '../../common/types';
import { getSummary } from '../../flows/report/summary';
import { getInvoicesSummary } from '../../flows/invoicesSummary';
import { getPanNumberAndBusiness } from '../../utils/businessDetails';
import Loading from '../loader/loader';
import {
  HeaderText,
  IllustrationText,
  InvoiceContainer,
  InvoiceDiv,
  InvoiceImg,
} from '../alerts/styles';
import { einvoiceSummaryDtos } from './constants';
import { EventIDs } from '../../analytics/events';
import { track } from '../../analytics/analytics';
import NoBusiness from '../noBusiness/noBusiness';
import Toast from '../Toast';

const Invoices = () => {
  const [calEnabled, setCalEnabled] = useState(false);
  const [rangeEnabled, setRangeEnabled] = useState(false);
  const [startValue, setStartValue] = useState(
    localStorage.getItem('START_DATE') ||
      moment().subtract(6, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss')
  );
  const [endValue, setEndValue] = useState(
    localStorage.getItem('END_DATE') ||
      moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
  );

  const [selectedDateRange, setSelectedDateRange] = useGlobalState('rangeType');
  const [loading, setLoading] = useGlobalState('loadingState');
  const [fetchingStatus, setFetchingStatus] = useGlobalState('dataFetch');
  const [complianceOrgID, setComplianceOrgID] = useGlobalState(
    'complianceCardOrgID'
  );
  const [page, setPage] = useGlobalState('pageNumber');

  const irnMetadata: IRNSummaryDetails = {
    totalPendingIrnGeneration: 0,
    totalNoOfInvoices: 0,
    totalIrnGenerated: 0,
    totalIrnFailed: 0,
    totalIrnCancelled: 0,
  };

  const [invSummaryCardData, setInvSummaryCardData] = useState(irnMetadata);
  const [stopDataFetch, setStopDataFetch] = useState(false);
  const [businessLevel, setbusinessLevel] = useState(BusinessLevels.PAN);
  const [businessNumber, setbusinessNumber] = useState('');
  const [businessId, setbusinessId] = useState('');
  const [invListData, setIvListData] = useState<EinvoiceSummaryDTO[]>([
    einvoiceSummaryDtos,
  ]);
  const [showBottomLoader, setShowBottomLoader] = useState(false);

  const {
    businessDetails,
    orgId,
    businessHierarchy,
    email,
    businessName,
  } = useContext<Record<string, any>>(UserContext);

  const handleRangeChange = (e: any) => {
    if (e.target.value === Range.MONTH) {
      setStartValue(
        moment(endValue, 'YYYY-MM-DD HH:mm:ss')
          .subtract(30, 'days')
          .startOf('day')
          .format('YYYY-MM-DD HH:mm:ss')
      );
      setSelectedDateRange(Range.MONTH);
      localStorage.setItem('RANGE_TYPE', Range.MONTH);
    } else {
      setStartValue(
        moment(endValue, 'YYYY-MM-DD HH:mm:ss')
          .subtract(6, 'days')
          .startOf('day')
          .format('YYYY-MM-DD HH:mm:ss')
      );
      setSelectedDateRange(Range.WEEK);
      localStorage.setItem('RANGE_TYPE', Range.WEEK);
    }
    setRangeEnabled(false);
    setPage(0);
    setStopDataFetch(false);
    const payload = {
      email,
    };
    if (e.target.value === Range.MONTH) {
      track(EventIDs.INVOICES_PAGE_LAST30, payload);
    } else {
      track(EventIDs.INVOICES_PAGE_LAST7, payload);
    }
  };

  const onDateChange = (value: any) => {
    if (
      moment(endValue).endOf('day').format('YYYY-MM-DD HH:mm:ss') !==
      moment(value, 'YYYY-MM-DD').endOf('day').format('YYYY-MM-DD HH:mm:ss')
    ) {
      setEndValue(
        moment(value, 'YYYY-MM-DD').endOf('day').format('YYYY-MM-DD HH:mm:ss')
      );
      if (selectedDateRange) {
        if (selectedDateRange === 'MONTH') {
          setStartValue(
            moment(value, 'YYYY-MM-DD')
              .subtract(30, 'days')
              .startOf('day')
              .format('YYYY-MM-DD HH:mm:ss')
          );
        } else {
          setStartValue(
            moment(value, 'YYYY-MM-DD')
              .subtract(6, 'days')
              .startOf('day')
              .format('YYYY-MM-DD HH:mm:ss')
          );
        }
      }
      setPage(0);
      setStopDataFetch(false);
    }
    setCalEnabled(false);
  };

  useEffect(() => {
    businessDetails.addPageName('INVOICES');
    const payload = {
      email,
    };
    track(EventIDs.INVOICES_PAGE, payload);
    if (window.location.pathname === '/inv') {
      businessDetails.addPageName('INVOICES');
    }
    if (window.location.pathname === '/invcompliance') {
      businessDetails.addPageName('INVOICES_COMPLIANCE');
    }
  }, []);

  useEffect(() => {
    const loadingTimer = setTimeout(() => {
      if (fetchingStatus === 'FETCHING_DATA') {
        setLoading(true);
      } else if (loading) {
        setLoading(false);
      }
    }, 500);

    const bottomLoaderTimer = setTimeout(() => {
      if (fetchingStatus === 'FETCHING_LIST' && !showBottomLoader) {
        setShowBottomLoader(true);
      }
    }, 100);
    return () => {
      clearTimeout(loadingTimer);
      clearTimeout(bottomLoaderTimer);
    };
  }, [fetchingStatus]);

  const handleScroll = (e: any) => {
    if (
      e.target.scrollTop + window.innerHeight >= e.target.scrollHeight &&
      fetchingStatus !== 'FETCHING_LIST'
    ) {
      if (!stopDataFetch) {
        setPage(page + 1);
        setFetchingStatus('FETCHING_LIST');
      }
    }
    if (stopDataFetch && showBottomLoader) {
      setShowBottomLoader(false);
    }
  };

  const callSummaryApi = (orgIdValue: string) => {
    const { panNumber, business, businessId: bid } = getPanNumberAndBusiness(
      businessHierarchy,
      orgIdValue
    );
    getSummary(
      orgIdValue,
      endValue,
      startValue,
      businessHierarchy.businessDataStore[orgIdValue].level,
      business,
      panNumber,
      bid
    )
      .then((res) => {
        setInvSummaryCardData(res);
      })
      .catch((error) => {
        Toast.notify({
          description: ErrorToastText.SUMMARY,
          nature: ToastNature.ERROR,
        });
      });
  };

  const callInvoicesApi = (orgIdValue: string) => {
    const { level, business, businessId: bid } = getPanNumberAndBusiness(
      businessHierarchy,
      orgIdValue
    );

    getInvoicesSummary(
      startValue,
      endValue,
      businessHierarchy.businessDataStore[orgIdValue].level,
      business,
      orgIdValue,
      page,
      bid
    )
      .then((res) => {
        if (res.einvoiceSummaryDtos.length === 0) {
          setStopDataFetch(true);
          setShowBottomLoader(false);
        }
        if (page === 0) {
          setIvListData(res.einvoiceSummaryDtos);
        } else {
          const dataList = [...invListData, ...res.einvoiceSummaryDtos];
          setIvListData(dataList);
        }
        setFetchingStatus('COMPLETED');
        setLoading(false);
        setbusinessLevel(level);
        setbusinessNumber(business);
        setbusinessId(businessId);
      })
      .catch((error) => {
        setFetchingStatus('COMPLETED');
        setLoading(false);
        setbusinessLevel(level);
        setbusinessNumber(business);
        setbusinessId(businessId);
        Toast.notify({
          description: ErrorToastText.INVOICE,
          nature: ToastNature.ERROR,
        });
      });
  };

  useEffect(() => {
    if (businessHierarchy && businessHierarchy.data.length !== 0) {
      if (localStorage.getItem('COMPLIANCE_ID' || complianceOrgID)) {
        const complianceOrgIDValue =
          localStorage.getItem('COMPLIANCE_ID') || complianceOrgID;
        if (complianceOrgIDValue !== 'NOT_FOUND') {
          callSummaryApi(complianceOrgIDValue);
        } else {
          setFetchingStatus('COMPLETED');
          setLoading(false);
        }
      } else {
        let orgIdValue: string =
          localStorage.getItem('ORGID') || businessHierarchy.data[0].id;
        if (orgId) {
          orgIdValue = orgId;
        }
        businessDetails.addBusinessName(
          businessHierarchy.businessDataStore[orgIdValue].name
        );
        callSummaryApi(orgIdValue);
      }
      setFetchingStatus('FETCHING_DATA');
      localStorage.setItem('START_DATE', startValue);
      localStorage.setItem('END_DATE', endValue);
      if (page === 0) {
        setStopDataFetch(false);
      }
      setShowBottomLoader(false);
    } else {
      setFetchingStatus('NO_DATA');
    }
  }, [
    businessHierarchy,
    orgId,
    complianceOrgID,
    startValue,
    endValue,
    selectedDateRange,
    businessDetails,
  ]);

  useEffect(() => {
    if (businessHierarchy && businessHierarchy.data.length !== 0) {
      if (localStorage.getItem('COMPLIANCE_ID') || complianceOrgID) {
        const complianceOrgIDValue =
          localStorage.getItem('COMPLIANCE_ID') || complianceOrgID;
        if (complianceOrgIDValue !== 'NOT_FOUND') {
          callInvoicesApi(complianceOrgIDValue);
        } else {
          setFetchingStatus('COMPLETED');
          setLoading(false);
        }
      } else {
        let orgIdValue: string =
          localStorage.getItem('ORGID') || businessHierarchy.data[0].id;
        if (orgId) {
          orgIdValue = orgId;
        }
        businessDetails.addBusinessName(
          businessHierarchy.businessDataStore[orgIdValue].name
        );

        callInvoicesApi(orgIdValue);
      }
      localStorage.setItem('START_DATE', startValue);
      localStorage.setItem('END_DATE', endValue);
    } else {
      setFetchingStatus('NO_DATA');
    }
  }, [
    businessHierarchy,
    orgId,
    complianceOrgID,
    startValue,
    endValue,
    selectedDateRange,
    businessDetails,
    page,
  ]);

  return (
    <>
      <INVToolBar compliance={window.location.pathname === '/invcompliance'}>
        {calEnabled && (
          <DatePicker
            open={calEnabled}
            placeholder={moment(startValue, 'YYYY-MM-DD HH:mm:ss').format(
              'DD-MM-YYYY'
            )}
            onChange={onDateChange}
          />
        )}
        {!calEnabled && startValue && (
          <DateRange
            aria-hidden="true"
            onClick={() => {
              setCalEnabled(true);
              const payload = {
                email,
              };
              track(EventIDs.INVOICES_PAGE_CALENDAR, payload);
            }}
            onKeyDown={() => setCalEnabled(true)}
          >
            <img src={CALENDAR} alt="" width="24px" height="24px" />
            <If condition={selectedDateRange === Range.MONTH}>
              <RangeText>This Month,&nbsp;</RangeText>
              {moment(startValue).format('Do MMM')} -{' '}
              {moment(endValue).format('Do MMM')}
            </If>
            <If condition={selectedDateRange !== Range.MONTH}>
              <RangeText>This Week,&nbsp;</RangeText>{' '}
              {moment(startValue).format('Do MMM')} -{' '}
              {moment(endValue).format('Do MMM')}
            </If>
          </DateRange>
        )}
        <DateRangeText>
          {rangeEnabled && (
            <select
              style={{
                fontFamily: 'Nunito',
                fontSize: '12px',
                width: '91px',
                marginLeft: '5px',
                marginBottom: '5px',
              }}
              onChange={handleRangeChange}
              value={
                selectedDateRange === Range.TODAY ||
                selectedDateRange === Range.WEEK
                  ? Range.WEEK
                  : Range.MONTH
              }
            >
              <option value={Range.WEEK}>last 7 days</option>
              <option value={Range.MONTH}>last 30 days</option>
            </select>
          )}
          {!rangeEnabled && (
            <span
              onClick={() => {
                setRangeEnabled(true);
                const payload = {
                  email,
                };
                track(EventIDs.INVOICES_PAGE_EDIT_DURATION, payload);
              }}
            >
              Edit Duration
            </span>
          )}
        </DateRangeText>
      </INVToolBar>
      <If condition={loading === true}>
        <Loading
          text="Loading invoices"
          index={window.location.pathname === '/inv' ? 0 : 120}
        />
      </If>
      <If condition={loading === false}>
        <If condition={businessName !== 'No businesses added'}>
          <If
            condition={
              (localStorage.getItem('COMPLIANCE_ID') || complianceOrgID) !==
                'NOT_FOUND' && invListData.length !== 0
            }
          >
            <Container compliance={window.location.pathname === '/inv'}>
              <INVContainer id="inv" onScroll={handleScroll}>
                <INVSummary invSummaryCardData={invSummaryCardData} />
                <InvoicesList
                  data={invListData}
                  businessLevel={businessLevel}
                  businessNumber={businessNumber}
                  businessId={businessId}
                />
                {showBottomLoader && (
                  <img src={LOADER_BLUE} alt="" width="32px" height="32px" />
                )}
              </INVContainer>
            </Container>
            {/* <INVFooter compliance={window.location.pathname === '/invcompliance'}>
              <Flex flexDirection='row' width="100%" align-items="center" justify-content="space-between">
                <FooterBtn>Sort</FooterBtn>
                <FooterLine/>
                <FooterBtn> Filter </FooterBtn>
              </Flex>
            </INVFooter> */}
          </If>
          <If
            condition={
              (localStorage.getItem('COMPLIANCE_ID') || complianceOrgID) ===
                'NOT_FOUND' || invListData.length === 0
            }
          >
            <InvoiceContainer
              index={window.location.pathname === '/invcompliance' ? 70 : 0}
            >
              <InvoiceDiv>
                <InvoiceImg src={NO_INVOICE_FOUND} alt="" />
                <HeaderText>No Invoices found </HeaderText>
                <IllustrationText>
                  Try changing the branch or date range.
                </IllustrationText>
              </InvoiceDiv>
            </InvoiceContainer>
          </If>
        </If>
        <If condition={businessName === 'No businesses added'}>
          <NoBusiness />
        </If>
      </If>
    </>
  );
};

export default Invoices;
